module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('TextBox', {
    attrs: {
      "label": "Label_EmailAddress",
      "placeholder": "Placeholder_Email",
      "type": "email",
      "validate": _vm.$v.model,
      "modelPath": "email",
      "acc": "email"
    },
    on: {
      "input": _vm.$v.model.email.$touch
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('SelectList', {
    attrs: {
      "label": "Settings_Group_Index",
      "modelPath": "group",
      "acc": "group",
      "validate": _vm.$v.model,
      "options": _vm.groupOptions
    },
    on: {
      "input": _vm.$v.model.group.$touch
    },
    model: {
      value: (_vm.model.group),
      callback: function($$v) {
        _vm.$set(_vm.model, "group", $$v)
      },
      expression: "model.group"
    }
  }), _vm._v(" "), _c('Btn', {
    staticClass: "button--right",
    attrs: {
      "label": "Label_Next"
    },
    on: {
      "click": _vm.next
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8aedc62!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/members/MemberCreate.vue
// module id = 760
// module chunks = 1